import FormHandler from "../FormHandler";

export default class FieldHandler {
    protected static readonly SELECTOR: string
    public readonly fields: JQuery

    constructor(
        public readonly form: FormHandler
    ) {
        this.fields = this.form.el.find((this.constructor as typeof FieldHandler).SELECTOR)
    }

    public init() {
        if (this.fields.length < 1) {
            return
        }

        this.fields.each((i, el) => this.initField(jQuery(el)))
    }

    protected initField(el: JQuery) {
        console.error('TODO: implement initField function', this, el)
    }
}
